"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    InternalErrorCode: "InternalError",
    InvalidTokenErrorCode: "InvalidTokenError",
    NotAuthorizedErrorCode: "NotAuthorizedError",
    MissingHeaderErrorCode: "MissingHeaderError",
    TokenExpiredErrorCode: "TokenExpiredError",
    InvitationExpiredErrorCode: "InvitationExpiredError",
    UserNotConfirmedErrorCode: "UserNotConfirmedError",
    UserNotFoundErrorCode: "UserNotFoundError",
    IllegalOperationErrorCode: "IllegalOperationError",
    ValidationErrorCode: "ValidationError",
    EntityExistsErrorCode: "EntityExistsError",
    EntityNotFoundErrorCode: "EntityNotFoundError",
    InvalidArgumentErrorCode: "InvalidArgumentError",
    MutationErrorCode: "MutationError",
    ForcibleErrorCode: "ForcibleError",
    BillingNoCCLimitErrorCode: "BillingNoCCLimitError",
    BillingPlanLimitErrorCode: "BillingPlanLimitError",
    BillingPlanLimitWarningCode: "BillingPlanLimitWarning",
    ExternalServiceErrorCode: "ExternalServiceError",
    TeamMemberNotActiveErrorCode: "TeamMemberNotActiveError",
    BillingFeatureAccessErrorCode: "BillingFeatureAccessError",
    ThrottlingThresholdReachedErrorCode: "ThrottlingThresholdReachedError",
    SourceCodeErrorCode: "SourceCodeError",
};
